<div class="account-form-wrapper">
  <form
    class="form user-login-form user-form v-row"
    #form="ngForm"
    [formGroup]="sendVerificationForm"
    (ngSubmit)="sendVerification(form)"
    novalidate
  >
    <div class="row">
      <div class="col inner-fields">
        <h3>Reset Password</h3>
        <div class="item-fields">
          <div class="form-group m-t-xl">
            <label class="hidden-label">Enter Email Address to send Password reset link:</label>
            <input
              formControlName="username"
              name="username"
              type="text"
              autocapitalize="off"
              spellcheck="false"
              class="form-control"
              id="username"
              placeholder="Enter your Email"
              tabindex="1"
            />
            <div
              [hidden]="
                sendVerificationForm.controls['username'].valid || (!form.submitted && !sendVerificationForm.controls.username.touched)
              "
              class="alert alert-danger"
            >
              <span [hidden]="!sendVerificationForm.controls.username.errors?.email">Email is invalid.</span>

              <span [hidden]="!sendVerificationForm.controls.username.errors?.required">Email is Required</span>
            </div>
          </div>
          <div class="form-group text-end m-t">
            <button [loading]="siginingInProgress" type="submit" tabindex="4" class="w-100 m-t text-center btn-md btn-shadow">
              Send Verification Link
            </button>
          </div>
          <errors style="position: relative; top: 10px" [on]="signinFormErrors">
            {{ signinFormErrors }}
          </errors>
        </div>
      </div>
    </div>
  </form>
  <div class="powered-by text-center v-row">
    <div>
      Powered by
      <a href="https://cal.lk" target="_blank">CAL</a> | <a href="/terms-and-conditions">Disclaimer</a>
    </div>
  </div>
</div>
